import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-nav",
  "use": "icon-mobile-nav-usage",
  "viewBox": "0 0 28 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 20\" id=\"icon-mobile-nav\">\n    <g>\n        <path d=\"M30 7a1 1 0 0 1-1 1H3a1 1 0 0 1 0-2h26a1 1 0 0 1 1 1zm-5 8H3a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2zm-9 9H3a1 1 0 0 0 0 2h13a1 1 0 0 0 0-2z\" transform=\"translate(-2 -6)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol